<div class="tes-container">
  <mat-card class="mcd-taking-effect-soon" style="min-height: 300px;">
    <div class="taking-effect-soon-header">
      Upcoming Changes
      <!-- <mat-icon class="taking-effect-soon-info-icon" title="Standards taking effect in the next 30 days">info_outline</mat-icon> -->
    </div>
    <div
      *ngIf="loading"
      style="height: 150px; display: flex; justify-content: center; align-items: center;"
    >
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <div class="mcd-taking-effect-soon-list" *ngIf="!loading">
      <div
        class="mcd-taking-effect-soon-item"
        *ngFor="let record of upcomingStandards"
        routerLink="{{ record.redirectUrl }}"
      >
        <span class="mcd-taking-effect-soon-icon">
          <img [src]="record.icon" alt="" />
        </span>
        <div class="mcd-taking-effect-soon-body">
          <div class="mcd-taking-effect-soon-title">{{ record.title }}</div>
          <div class="mcd-taking-effect-soon-status" *ngIf="record.effectiveDate">
            <strong>New {{ record.standardTypeName }}</strong>
            <ng-container *ngIf="record.daysUntilEffect === 0"> &bull; In Effect Today</ng-container>
            <ng-container *ngIf="record.daysUntilEffect === 1"> &bull; In Effect in 1 day</ng-container>
            <ng-container *ngIf="record.daysUntilEffect > 1"> &bull; In Effect in {{ record.daysUntilEffect }} days</ng-container>
          </div>
        </div>
      </div>
      <div *ngIf="upcomingStandards.length === 0" class="taking-effect-soon-empty">
        No standards taking effect in the next 30 days.
      </div>
    </div>
  </mat-card>
</div>
